import axios from 'axios';
import { getStoredData, get_auth_key } from '../../util';

const getHeaders = (multiPartRequest = false) => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  return {
    Accept: 'application/json',
    'Content-Type': multiPartRequest ? 'multipart/form-data' : 'application/json',
    'x-access-token': storedData.token,
    'factory-id': localStorage.getItem('factoryId'),
  };
};

export const getVehicleRequestAPI = async (pageNo, perPageCount, options, vehicleRequestId = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleVehicleRequest = '';
    if (vehicleRequestId !== 0) {
      singleVehicleRequest = `/${vehicleRequestId}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests${singleVehicleRequest}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const editVehicleReq = async (form, id) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${id}`, settings.body, {
      headers: settings.headers,
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const deleteVehicleRequest = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(e.message);
  }
};

export const getVehicleRequest = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const deleteVehicleRequestAttachment = async (id, field) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${id}/filefrom/${field}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(e.message);
  }
};

export const getQuotationRequest = async (requestId, quotationId) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${requestId}/quotations/${quotationId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getQuotationListRequest = async (pageNo, perPageCount, options, vehicleId, quotationId = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleQuotationRequest = '';
    if (quotationId !== 0) {
      singleQuotationRequest = `/${quotationId}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        '/vm/vehicle-requests/' +
        vehicleId +
        `/quotations${singleQuotationRequest}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const editQuotation = async (form, vehicleId, quotationId) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.put(
      process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${vehicleId}/quotations/${quotationId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const approveQuotation = async (vehicleId, quotationId) => {
  try {
    const res = await axios.put(
      process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${vehicleId}/quotations/${quotationId}?update_status=true`,
      [],
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const deleteQuotation = async (quotationId, requestId) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${requestId}/quotations/${quotationId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(e.message);
  }
};

export const createVehicleRequest = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/vehicle-requests', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const createAfterVehicleRequest = async (form, after, runningId) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests?after=${after}&runningId=${runningId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const createQuotation = async (form, id) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/vehicle-requests/' + id + '/quotations', settings.body, {
      headers: settings.headers,
    });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

// Reference
export const createReference = async (form, id, vehicleRequestId) => {
  const settings = {
    headers: getHeaders(),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL + '/vm/vehicle-requests/' + id + `/references?vehicleRequestId=${vehicleRequestId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const editReference = async (request, id, quotationId) => {
  const settings = {
    headers: getHeaders(),
    body: request,
  };
  try {
    const res = await axios.put(
      process.env.REACT_APP_BASE_URL + '/vm/vehicle-requests/' + quotationId + '/references/' + id,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getReferenceAPI = async (pageNo, perPageCount, options, quotationId, referenceId = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + '/vm/vehicle-requests/' + quotationId + `/references?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getReferenceRequest = async (referenceId, quotationId) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${quotationId}/references/${referenceId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const deleteReference = async (quotationId, referenceId) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${quotationId}/references/${referenceId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(e.message);
  }
};

export const createPurchaseOrder = async (form, vehicleRequestId, quotationId) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL + '/vm/vehicle-requests/' + vehicleRequestId + '/quotations/' + quotationId + '/purchaseorder',
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const createAfterPurchaseOrder = async (form, after, runningId, vehicleRequestId) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL +
        '/vm/vehicle-requests/' +
        vehicleRequestId +
        '/quotations/' +
        0 +
        `/purchaseorder?after=${after}&runningId=${runningId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getPurchaseOrder = async (pageNo, perPageCount, options, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singlePurchaseOrder = '';
    if (id !== 0) {
      singlePurchaseOrder = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/vehicle-requests/purchaseorders${singlePurchaseOrder}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSinglePurchaseOrder = async (purchaseId) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/purchaseorders/${purchaseId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const deletePurchaseOrder = async (id, vehicleIdToDeleted) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/purchaseorders/${id}?vehicleIdToDeleted=${vehicleIdToDeleted}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(e.message);
  }
};

export const createRunningVehicle = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/running-vehicle', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getRunningVehicle = async (pageNo, perPageCount, options, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleRunningVehicle = '';
    if (id !== 0) {
      singleRunningVehicle = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/running-vehicle${singleRunningVehicle}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSingleRunningVehicle = async (runningVehicleId) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/running-vehicle/${runningVehicleId}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const updateStatusRunningVehicle = async (vehicleId) => {
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/${vehicleId}?update_status=true`, [], {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const updateStatusPurchaseOrder = async (id) => {
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/purchaseorders/${id}?update_status=true`, [], {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const editPurchaseOrder = async (form, id) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/vm/vehicle-requests/purchaseorders/${id}`, settings.body, {
      headers: settings.headers,
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const createServiceRemainder = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/service-remainder', settings.body, { headers: settings.headers });
  return res.data;
};

export const createRemainder = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/remainder', settings.body, { headers: settings.headers });
  return res.data;
};

export const createDocument = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/document', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getServiceRemainder = async (pageNo, options, perPageCount, runningVehicleId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleServiceRemainder = '';
    if (id !== 0) {
      singleServiceRemainder = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/service-remainder/${runningVehicleId}/services${singleServiceRemainder}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getRemainder = async (pageNo, options, perPageCount, runningVehicleId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleRemainder = '';
    if (id !== 0) {
      singleRemainder = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/remainder/${runningVehicleId}/services${singleRemainder}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );

    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getDocument = async (pageNo, options, perPageCount, runningVehicleId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleDocument = '';
    if (id !== 0) {
      singleDocument = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/document/${runningVehicleId}${singleDocument}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSingleServiceRemainder = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/service-remainder/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getSingleRemainder = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/remainder/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getSingleDocument = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/document/single/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const editServiceRemainder = async (request, id) => {
  const settings = {
    headers: getHeaders(),
    body: request,
  };
  const res = await axios.put(process.env.REACT_APP_BASE_URL + '/vm/service-remainder/' + id, settings.body, {
    headers: settings.headers,
  });
  return res.data;
};

export const editRemainder = async (request, id) => {
  const settings = {
    headers: getHeaders(),
    body: request,
  };
  const res = await axios.put(process.env.REACT_APP_BASE_URL + '/vm/remainder/' + id, settings.body, { headers: settings.headers });
  return res.data;
};

export const editDocument = async (request, id) => {
  const settings = {
    headers: getHeaders(),
    body: request,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + '/vm/document/' + id, settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const deleteServiceRemainder = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/service-remainder/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(error.response.data.data.message);
  }
};

export const deleteRemainder = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/remainder/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(error.response.data.data.message);
  }
};
export const deleteDocument = async (id, purchaseOrderId) => {
  try {
    const url = purchaseOrderId
      ? `${process.env.REACT_APP_BASE_URL}/vm/document/${id}/filefrom/${purchaseOrderId}`
      : `${process.env.REACT_APP_BASE_URL}/vm/document/${id}`;

    const res = await axios.delete(url, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(error.response.data.data.message);
  }
};

export const createBreakdown = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/breakdown', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getBreakdown = async (pageNo, options, perPageCount, runningVehicleId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleBreakdown = '';
    if (id !== 0) {
      singleBreakdown = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/breakdown/${runningVehicleId}/breakdowns${singleBreakdown}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSingleBreakdown = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/breakdown/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const editBreakdown = async (request, id) => {
  const settings = {
    headers: getHeaders(true),
    body: request,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + '/vm/breakdown/' + id, settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const deleteBreakdown = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/breakdown/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(error.response.data.data.message);
  }
};

export const createSpare = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/spare', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getSpare = async (pageNo, options, perPageCount, runningVehicleId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleSpare = '';
    if (id !== 0) {
      singleSpare = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/spare/${runningVehicleId}/spares${singleSpare}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSingleSpare = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/spare/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const editSpare = async (request, id) => {
  const settings = {
    headers: getHeaders(true),
    body: request,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + '/vm/spare/' + id, settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const deleteSpare = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/spare/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(error.response.data.data.message);
  }
};

export const createSpareRequest = async (form) => {
  const settings = {
    headers: getHeaders(),
    body: form,
  };
  try {
    const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/spare/spare-request', settings.body, { headers: settings.headers });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const getSpareRequest = async (pageNo, options, perPageCount, runningVehicleId, id = 0) => {
  try {
    let query = '';
    Object.keys(options).forEach((option) => {
      query = `${query}&${option}=${options[option]}`;
    });
    let singleSpareRequest = '';
    if (id !== 0) {
      singleSpareRequest = `/${id}`;
    }
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/spare/${runningVehicleId}/spare-request${singleSpareRequest}?page=${pageNo}&limit=${perPageCount}${query}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSingleSpareRequest = async (runningVehicleId, spareRequestId) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/spare/${runningVehicleId}/spare-request/${spareRequestId}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};
export const editSpareRequestMethod = async (request, id, runningVehicleId) => {
  const settings = {
    headers: getHeaders(),
    body: request,
  };
  try {
    const res = await axios.put(
      process.env.REACT_APP_BASE_URL + `/vm/spare/${runningVehicleId}/spare-request/${id}?update_status=false`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};
export const deleteSpareRequest = async (id) => {
  try {
    const res = await axios.delete(process.env.REACT_APP_BASE_URL + `/vm/spare/spare-request/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return new Error(error.response.data.data.message);
  }
};

export const createResellScrap = async (form) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  const res = await axios.post(process.env.REACT_APP_BASE_URL + '/vm/resell-scrap', settings.body, { headers: settings.headers });
  return res.data;
};

export const getSingleResellScrap = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/resell-scrap/${id}`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const editRunningVehicle = async (form, id) => {
  const settings = {
    headers: getHeaders(true),
    body: form,
  };
  try {
    const res = await axios.put(process.env.REACT_APP_BASE_URL + `/vm/running-vehicle/${id}`, settings.body, { headers: settings.headers });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const approveSpareRequest = async (form, vehicleId, spareRequestId) => {
  const settings = {
    headers: getHeaders(),
    body: form,
  };
  try {
    const res = await axios.put(
      process.env.REACT_APP_BASE_URL + `/vm/spare/${vehicleId}/spare-request/${spareRequestId}?update_status=true`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw e;
  }
};

export const getAllDashboardCount = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/dashboard/counts`, { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getVehicleRequestReport = async (startDate, endDate, vehicleName, status, initiatedBy, conditionType) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/reports/vehicle-request-report?startDate=${startDate}&endDate=${endDate}&vehicleName=${vehicleName}&status=${status}&initiatedBy=${initiatedBy}&conditionType=${conditionType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};
export const getPurchaseOrderReport = async (startDate, endDate, vehicleName, purchaseNumber, initiatedBy, conditionType) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/reports/purchase-order-report?startDate=${startDate}&endDate=${endDate}&vehicleName=${vehicleName}&purchaseNumber=${purchaseNumber}&initiatedBy=${initiatedBy}&conditionType=${conditionType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};
export const getRunningVehicleReport = async (startDate, endDate, vehicleModelName, registrationNumber, conditionType) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/reports/running-vehicle-report?startDate=${startDate}&endDate=${endDate}&vehicleModelName=${vehicleModelName}&registrationNumber=${registrationNumber}&conditionType=${conditionType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getServiceRemainderReport = async (
  startDate,
  endDate,
  vehicleName,
  servicedStartDate,
  servicedEndDate,
  serviceStatus,
  conditionType
) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/reports/service-remainder-report?startDate=${startDate}&endDate=${endDate}&vehicleName=${vehicleName}&servicedStartDate=${servicedStartDate}&servicedEndDate=${servicedEndDate}&serviceStatus=${serviceStatus}&conditionType=${conditionType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getBreakdownReport = async (
  startDate,
  endDate,
  vehicleName,
  servicedStartDate,
  servicedEndDate,
  breakdownStatus,
  conditionType
) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/reports/breakdown-report?startDate=${startDate}&endDate=${endDate}&vehicleName=${vehicleName}&servicedStartDate=${servicedStartDate}&servicedEndDate=${servicedEndDate}&breakdownStatus=${breakdownStatus}&conditionType=${conditionType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getVehicleDetailRequestReport = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/reports/vehicle-detail-request-report?vehicleId=${id}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getFullRunningVehicleReport = async (id, isRunningVehicle) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/reports/vehicle-detail-request-report?vehicleId=${id}&isRunningVehicle=${isRunningVehicle}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getFullRunningVehicleReportTwo = async (id, isRunningVehicle) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/reports/vehicle-detail-request-report-two?vehicleId=${id}&isRunningVehicle=${isRunningVehicle}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getFullRunningVehicleReportThree = async (id) => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + `/vm/reports/vehicle-detail-request-report-three?vehicleId=${id}`, {
      headers: getHeaders(),
    });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getFullRunningVehicleReportOne = async (id, isRunningVehicle) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/reports/vehicle-detail-request-report-one?runningId=${id}&isRunningVehicle=${isRunningVehicle}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(e.message);
  }
};

export const getSinglePurchaseOrderReport = async (id, vehicleId) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL + `/vm/reports/purchase-order-reportss?purchaseId=${id}&vehicleId=${vehicleId}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getUpcomingServices = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + '/vm/dashboard/services?type=coming', { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getUpcomingRemainders = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + '/vm/dashboard/remainders?type=coming', { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getOverdueServices = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + '/vm/dashboard/services?type=due', { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const transferingVehicle = async (form, selectedFactoryId, runningId) => {
  const settings = {
    headers: getHeaders(),
    body: form,
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_BASE_URL + `/vm/running-vehicle/transfer-vehicle?selectedFactoryId=${selectedFactoryId}&runningId=${runningId}`,
      settings.body,
      { headers: settings.headers }
    );
    return await res.data;
  } catch (error) {
    if (error.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    throw new Error(error.response.data.data.message);
  }
};

export const logout = async () => {
  try {
    const res = await axios.get(process.env.REACT_APP_BASE_URL + '/vm/users/logout', { headers: getHeaders() });
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};

export const getSingleServiceInfo = async (id, runningVehicleId, vehicleType) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/vm/reports/service-info?serviceId=${id}&runningVehicleId=${runningVehicleId}&vehicleType=${vehicleType}`,
      { headers: getHeaders() }
    );
    return await res.data;
  } catch (e) {
    if (e.response.status === 401) {
      // unauthorized
      window.location.href = process.env.REACT_APP_FRONTEND_URL
    }
    return e;
  }
};
